<template>
  <section>
      <div class="content-header">
        <h2>Online resources</h2>
      </div>
      <div class="content-wrapper">
        <ul>
          <li><a href="https://wsmh-cms.mediresource.com/wsmh/assets/ijq4md4roxwkgck0" target="_blank">From Surviving to Thriving: Developing Personal and Academic Resilience (Workplace Strategies for Mental Health)</a></li>
        </ul>
      </div>
  </section>
</template>

<script>
// import Accordion from '../components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
    }
  },

  mounted () {
  }
}
</script>

<style>

</style>
